import { render, staticRenderFns } from "./OpenEndedPreview.vue?vue&type=template&id=0fe83b59&"
import script from "./OpenEndedPreview.vue?vue&type=script&lang=js&"
export * from "./OpenEndedPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports